import script from "./CvPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CvPage.vue?vue&type=script&setup=true&lang=js"

import "./CvPage.vue?vue&type=style&index=0&id=10cacac9&scoped=true&lang=css"
import "./CvPage.vue?vue&type=style&index=1&id=10cacac9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10cacac9"]])

export default __exports__